import { useContext, useEffect, useRef } from 'react';
import { GlobalMobileContext } from '../contexts/globalMobileContext';
import io from "socket.io-client"

import { sortNotesByUpdatedAt } from './UtilitaryFunctions';

const SocketManagerMobile = () => {
    const { 
        mobileSocketRef, socketToken, currentConference, setCurrentUser, currentPage, setCurrentPage, currentUser, setCurrentTopicsList, setCurrentNotesList, setCurrentError, 
        selectedEntity, setSelectedEntity 
    } = useContext(GlobalMobileContext);

    const currentConferenceRef = useRef();
    const currentPageRef = useRef();
    const selectedEntityRef = useRef();
    const currentUserRef = useRef();

    useEffect(() => {
        currentUserRef.current = currentUser;
    }, [currentUser]);

    useEffect(() => {
        currentConferenceRef.current = currentConference;
    }, [currentConference])

    useEffect(() => {
        currentPageRef.current = currentPage;
    }, [currentPage])

    useEffect(() => {
        selectedEntityRef.current = selectedEntity;
    }, [selectedEntity])

    useEffect(() => {

        mobileSocketRef.current = io.connect(process.env.REACT_APP_CMS_URL, {
            secure: true,
            reconnect: true,
            rejectUnauthorized: true,
            query: { token: socketToken }
        })

        mobileSocketRef.current.on('connect', function () {
            mobileSocketRef.current.emit("MOBILE_ADD_CLIENT_TO_SOCKETS");

            if (socketToken && !currentUserRef.current) {
                mobileSocketRef.current.emit('MOBILE_GET_USER_BY_TOKEN', socketToken, (callback) => {
                    if (!callback.error) {
                        setCurrentUser(callback.response);
                    } else {
                        console.error('Failed to load user:', callback.response);
                    }
                });
            }
        });


        mobileSocketRef.current.on('MOBILE_REFRESH_CONFERENCE_TOPICS', function (conferenceId) {
            if (currentConferenceRef.current?._id === conferenceId && currentPageRef.current === 'Topics') {
                mobileSocketRef.current.emit("MOBILE_CONFERENCE_GET_TOPICS", conferenceId, currentUser._id, (callback) => {
                    if (!callback.error) {
                        setCurrentTopicsList(callback.response);
                        setCurrentPage("Topics");

                        if (selectedEntityRef.current) {
                            const topicId = selectedEntityRef.current._id;
                            const foundTopic = callback.response.find(topic => topic._id === topicId);

                            let foundEntity = foundTopic;

                            if (!foundEntity) {
                                for (let topic of callback.response) {
                                    const foundSubtopic = topic.subtopics?.find(sub => sub._id === topicId);
                                    if (foundSubtopic) {
                                        foundEntity = foundSubtopic;
                                        break;
                                    }
                                }
                            }

                            setSelectedEntity(foundEntity || null);

                        }
                    } else {
                        setCurrentError(callback.error)
                    }
                });
            }
        });


        mobileSocketRef.current.on('MOBILE_REFRESH_CONFERENCE_NOTES', function (conferenceId) {
            if (currentConferenceRef.current?._id === conferenceId && currentPageRef.current === 'Notes') {
                mobileSocketRef.current.emit("MOBILE_CONFERENCE_GET_NOTES", conferenceId, currentUser._id, (callback) => {
                    if (!callback.error) {
                        let notes = sortNotesByUpdatedAt(callback.response)
                        setCurrentNotesList(notes)
                        setCurrentPage("Notes")
                    } else {
                        setCurrentError(callback.error)
                    }
                });

            }
        });




        return () => {
            mobileSocketRef.current.disconnect();
        }

    }, [])

    return (
        <> </>
    );
}

export default SocketManagerMobile;